import React from 'react'
import { BugsnagNotify } from '@adsk/napi-bugsnag'

interface PropTypes {
	componentName: string
	componentVersion: string
	FallbackComponent?: JSX.Element
	children: JSX.Element | JSX.Element[]
}

interface StateTypes {
	hasError: boolean
}

const FallbackComponent = (): JSX.Element => {
	return <div>Oops! Something went wrong! Refresh the page to try again.</div>
}
class ErrorBoundary extends React.Component<PropTypes, StateTypes> {
	constructor(props: PropTypes) {
		super(props)
		this.state = { hasError: false }
	}

	static getDerivedStateFromError(): StateTypes {
		return { hasError: true }
	}

	componentDidCatch(error: Error): void {
		const metaData = {
			componentName: this.props.componentName,
			componentVersion: this.props.componentVersion,
			message: error.message,
		}
		BugsnagNotify(error, metaData)
	}

	render(): JSX.Element | JSX.Element[] {
		if (this.state.hasError) {
			return this.props.FallbackComponent ?? <FallbackComponent />
		}

		return this.props.children
	}
}

export default ErrorBoundary
